<template>
  <div>
    <h3 class="mb-4">
      <strong>Purchaser Details</strong>
    </h3>

    <Form
      v-slot="{ errors }"
      @submit="onSubmit"
    >
      <b-form-group sub-label="Full name">
        <template #label>
          <i class="bi bi-person-fill me-2" /> YOUR NAME
        </template>

        <Field
          v-model="formStore.formData.fullName"
          name="fullName"
          rules="required"
          :class="{ 'is-invalid': errors.fullName }"
          as="b-form-input"
        />
        <ErrorMessage
          class="text-danger"
          name="fullName"
        />
      </b-form-group>

      <!-- Email -->
      <b-form-group sub-label="Your email address">
        <template #label>
          <i class="bi bi-envelope-fill me-2" /> YOUR EMAIL
        </template>
        <Field
          v-model="formStore.formData.email"
          name="email"
          rules="required|email"
          :class="{ 'is-invalid': errors.email }"
          as="b-form-input"
          type="email"
        />
        <ErrorMessage
          class="text-danger"
          name="email"
        />
      </b-form-group>

      <!-- Confirm Email -->
      <b-form-group sub-label="Your email address again">
        <template #label>
          <i class="bi bi-envelope-check-fill me-2" /> CONFIRM EMAIL
        </template>
        <Field
          v-model="formStore.formData.confirmEmail"
          name="confirmEmail"
          rules="required|confirmed:@email"
          :class="{ 'is-invalid': errors.confirmEmail }"
          as="b-form-input"
          type="email"
        />
        <ErrorMessage
          class="text-danger"
          name="confirmEmail"
        />
      </b-form-group>

      <!-- Phone Number -->
      <b-form-group sub-label="OPTIONAL">
        <template #label>
          <i class="bi bi-telephone-fill me-2" /> PHONE NUMBER
        </template>
        <b-form-input
          v-model="formStore.formData.phoneNumber"
          type="tel"
          inputmode="numeric"
          @keydown="blockNonDigits"
        />
      </b-form-group>

      <!-- Country -->
      <b-form-group>
        <template #label>
          <i class="bi bi-geo-alt-fill me-2" /> COUNTRY
        </template>
        <b-form-select
          v-model="formStore.formData.country"
          :options="countries"
        />
      </b-form-group>

      <div class="d-flex justify-content-between">
        <b-button
          variant="light"
          @click="formStore.prevStep"
        >
          BACK
        </b-button>
        <b-button
          variant="primary"
          type="submit"
          :disabled="Object.keys(errors).length > 0"
        >
          NEXT
        </b-button>
      </div>
    </Form>
  </div>
</template>

<script>
import { useFormStore } from "../stores/formStore";
import { Form, Field, ErrorMessage, defineRule } from "vee-validate";
import { required, email, confirmed } from "@vee-validate/rules";

defineRule("required", required);
defineRule("email", email);
defineRule("confirmed", confirmed);

export default {
  components: {
    Form,
    Field,
    ErrorMessage,
  },
  data() {
    return {
      formStore: useFormStore(),
      countries: [
        "Ireland",
        "United Kingdom",
        "United States",
        "Canada",
        "Australia",
      ],
    };
  },
  mounted() {
   
  },
  methods: {
    onSubmit() {
      this.formStore.nextStep();
    },
     blockNonDigits(e) {
      if (!/[0-9]/.test(e.key) && e.key !== 'Backspace' && e.key !== 'Tab') {
        e.preventDefault()
      }
    }
  },
};
</script>

<style scoped>
.is-invalid {
  border-color: #dc3545;
}

.text-danger {
  color: #dc3545;
  font-size: 0.875rem;
  margin-top: 0.25rem;
}
</style>
